import React, { useMemo, useState } from 'react';
import { PageHeading } from '../../../../../../SharedComponents';
import { BranchLeavesIcon, UserOneIcon } from '../../../../../../assets/icons';
import OverviewTable from './OverviewTable';
import { ButtonBase } from '@material-ui/core';

function AgentTable({ data }) {
  const [viewAll, setViewAll] = useState(false);
  const rankedData = useMemo(() => {
    if (!data || data.length === 0) return [];

    return [...data]
      .sort((a, b) => b.claimsCount - a.claimsCount)
      .map((item, index) => ({
        ...item,
        rank: index + 1,
      }));
  }, [data]);
  const displayedData = viewAll ? rankedData : rankedData.slice(0, 5);
  return (
    <>
      <div className='leadxchange-table-header'>
        <PageHeading
          headerTitle={'Top performing agent '}
          headerTitleClasses={'card-title'}
          wrapperClasses={'mb-0'}
        />
        {rankedData.length > 5 && (
          <ButtonBase onClick={() => setViewAll(!viewAll)}>
            <div className='view-all-text'>
              {viewAll ? 'Show Less' : 'View All'}
            </div>
          </ButtonBase>
        )}
      </div>
      <div className='leadxchange-divider' />
      <OverviewTable
        columns={[
          { key: 'rank', label: 'Rank' },
          { key: 'agentName', label: 'Agent' },
          { key: 'branch', label: 'Environment' },
          { key: 'claimsCount', label: 'Claims' },
          { key: 'transactedLeadsCount', label: 'Converted claims' },
        ]}
        data={displayedData}
        renderCell={(key, value) => {
          if (key === 'rank') {
            return (
              <div className='rank_cell'>
                <BranchLeavesIcon
                  width='29'
                  height='32'
                  fill='#7F6944'
                />
                <span className='rank_value'>{value}</span>
                <BranchLeavesIcon
                  width='29'
                  height='32'
                  fill='#7F6944'
                  style={{ transform: 'scaleX(-1)' }}
                />
              </div>
            );
          }
          if (key === 'agentName') {
            return (
              <div className='agent-cell'>
                <div className='agent-cell__icon'>
                  <UserOneIcon
                    width='24'
                    height='24'
                    fill={'#667085'}
                    style={{ flexShrink: '0' }}
                  />
                </div>
                <span className='agent-cell__name'>{value}</span>
              </div>
            );
          }
          return value;
        }}
      />
    </>
  );
}

export default AgentTable;
